import { parse } from 'cookie'

import { formatLaunch, formatModule } from '../launchExportFormatutils'
import { openOauthWindow, isOauthNeeded } from '../oauthUtils'

import { setCookies } from '~lib/helpers'
import {
  LaunchModuleContentType,
  LaunchContentType,
} from '~modules/launches/containers/DocumentsIntegrationModal/utils'

export const getConfluenceApiUrl = (url: string, cloudID: string) => {
  const title = url.split('/').reverse()[0]
  const spaceKey = url.split('spaces/')[1].split('/')[0]
  const apiUrl = `https://api.atlassian.com/ex/confluence/${cloudID}/rest/api/content?spaceKey=${spaceKey}&title=${title}&expand=space,body.export_view`
  return apiUrl
}

export const getAccessToken = () => {
  const accessToken = parse(document.cookie).CONFLUENCE_ACCESS_TOKEN
  return accessToken
}

export const getRefreshToken = () => {
  const accessToken = parse(document.cookie).CONFLUENCE_REFRESH_TOKEN
  return accessToken
}

export const confluenceOauth2 = async (originHref: string, originUrl: string) => {
  if (await isOauthNeeded('CONFLUENCE')) {
    const encodedRedirUri = encodeURIComponent(`${originUrl}/api/confluenceCallback`)
    const clientID = process.env.NEXT_PUBLIC_CONFLUENCE_CLIENT_ID
    const state = Buffer.from(`${originHref} ${originUrl}`).toString('base64')
    const authUrl = `https://auth.atlassian.com/authorize?audience=api.atlassian.com&client_id=${clientID}&scope=offline_access%20read%3Aconfluence-space.summary%20write%3Aconfluence-space%20read%3Aconfluence-content.all%20read%3Aconfluence-content.summary%20write%3Aconfluence-content%20write%3Aconfluence-file%20read%3Aconfluence-props%20write%3Aconfluence-props%20manage%3Aconfluence-configuration%20search%3Aconfluence%20read%3Aconfluence-content.permission&redirect_uri=${encodedRedirUri}&state=${state}&response_type=code&prompt=consent`
    const payload: any = await openOauthWindow(authUrl)
    const { CONFLUENCE_ACCESS_TOKEN, CONFLUENCE_REFRESH_TOKEN, CONFLUENCE_SCOPE } = payload
    setCookies({ CONFLUENCE_REFRESH_TOKEN, CONFLUENCE_ACCESS_TOKEN, CONFLUENCE_SCOPE })
  }
}

export const getConfluenceCloudID = async () => {
  const accResBody = JSON.stringify({
    apiUrl: 'https://api.atlassian.com/oauth/token/accessible-resources',
    apiMethod: 'GET',
    accessToken: getAccessToken(),
  })

  const resAccRes = await fetch('/api/confluenceRest', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: accResBody,
  })

  const jsonAccRes = await resAccRes.json()

  const { apiRes } = jsonAccRes
  const { message } = apiRes as { message: string }
  if (message && message === 'Unauthorized') {
    const refreshTokenBody = JSON.stringify({
      apiUrl: 'https://auth.atlassian.com/oauth/token',
      apiMethod: 'POST',
      accessToken: getAccessToken(),
      refreshToken: getRefreshToken(),
      apiAction: 'refresh-token',
    })

    const resRefreshToken = await fetch('/api/confluenceRest', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: refreshTokenBody,
    })

    const jsonRefreshToken = await resRefreshToken.json()

    const {
      apiRes: { access_token: accessToken, refresh_token: refreshToken },
    } = jsonRefreshToken

    setCookies({ CONFLUENCE_REFRESH_TOKEN: refreshToken, CONFLUENCE_ACCESS_TOKEN: accessToken })

    const accResBody2 = JSON.stringify({
      apiUrl: 'https://api.atlassian.com/oauth/token/accessible-resources',
      apiMethod: 'GET',
      accessToken,
    })

    const resAccRes2 = await fetch('/api/confluenceRest', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: accResBody2,
    })

    const jsonAccRes2 = await resAccRes2.json()

    const {
      apiRes: [{ id: cloudID }],
    } = jsonAccRes2

    return cloudID
  }

  const {
    apiRes: [{ id: cloudID }],
  } = jsonAccRes

  return cloudID
}

export const formatConfluenceContent = (pageTitle: string, content: LaunchContentType | LaunchModuleContentType) => {
  let html = ''
  if (pageTitle.search('Ignition') > -1) {
    html = formatLaunch(content as LaunchContentType, 'CONFLUENCE')
  } else {
    html = formatModule(pageTitle, content as LaunchModuleContentType, 'CONFLUENCE')
  }

  return html
}
